import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

const DEFAULT_PW = "Amravati@2026";

const SECTIONS = [
  { key: "district", title: "जिल्हास्तरीय अधिकारी", roles: ["collector", "rdc", "aro", "viewer", "accountant"] },
  { key: "sdo", title: "उपविभागीय अधिकारी (SDO)", roles: ["sdo"] },
  { key: "tehsildar", title: "तहसीलदार", roles: ["tehsildar"] },
  { key: "circle", title: "मंडळ अधिकारी", roles: ["circle"] },
];

export default function CredentialsSheet() {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const d = await api.officerAccounts(); setAccounts(Array.isArray(d) ? d : []); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <style>{`@media print { .no-print { display:none !important; } @page { size: A4; margin: 12mm; } }`}</style>
      <div className="no-print flex items-center justify-between border-b border-slate-200 bg-[#f6f2e6] px-6 py-3">
        <button onClick={() => navigate("/officer/admin")} data-testid="cred-back" className="flex items-center gap-1.5 rounded-full border border-[#1b5e3f]/30 px-3.5 py-1.5 text-[13px] font-semibold text-[#1b5e3f] hover:bg-[#1b5e3f]/5"><ArrowLeft className="h-4 w-4" /> मागे</button>
        <button onClick={() => window.print()} data-testid="cred-print" className="flex items-center gap-1.5 rounded-full bg-[#1b5e3f] px-5 py-2 text-[13.5px] font-semibold text-white hover:bg-[#144d33]"><Printer className="h-4 w-4" /> प्रिंट करा</button>
      </div>

      <div className="mx-auto max-w-3xl px-8 py-8" data-testid="credentials-sheet">
        <div className="mb-1 text-center">
          <h1 className="font-head text-[22px] font-semibold text-[#1b5e3f]">जिल्हाधिकारी कार्यालय, अमरावती</h1>
          <p className="text-[13px] text-[#c2570a]">आपले सरकार सेवा केंद्र — अधिकारी लॉगिन क्रेडेन्शियल शीट</p>
        </div>
        <p className="mb-5 rounded-lg border-l-4 border-[#E0A106] bg-[#fdf7e5] px-3 py-2 text-[12px] text-[#8a5a06]">
          पहिल्या लॉगिनसाठी default पासवर्ड: <b className="font-latin">{DEFAULT_PW}</b>. सुरक्षिततेसाठी पहिल्या लॉगिननंतर पासवर्ड बदलणे बंधनकारक आहे.
        </p>

        {loading ? <p className="py-10 text-center text-slate-400">लोड होत आहे...</p> : SECTIONS.map((s) => {
          const rows = accounts.filter((a) => s.roles.includes(a.role));
          if (rows.length === 0) return null;
          return (
            <div key={s.key} className="mb-5 break-inside-avoid">
              <h2 className="mb-1.5 rounded bg-[#1b5e3f] px-3 py-1.5 text-[13.5px] font-bold text-white">{s.title} ({rows.length})</h2>
              <table className="w-full border-collapse text-[12.5px]">
                <thead>
                  <tr className="bg-[#faf6ec] text-left text-slate-500">
                    <th className="border border-[#e2d9c4] px-2.5 py-1.5">पद / नाव</th>
                    <th className="border border-[#e2d9c4] px-2.5 py-1.5">कार्यक्षेत्र</th>
                    <th className="border border-[#e2d9c4] px-2.5 py-1.5">वापरकर्तानाव</th>
                    <th className="border border-[#e2d9c4] px-2.5 py-1.5">पासवर्ड</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((a) => (
                    <tr key={a.id || a.username}>
                      <td className="border border-[#e2d9c4] px-2.5 py-1.5">{a.name}</td>
                      <td className="border border-[#e2d9c4] px-2.5 py-1.5">{a.jurisdiction || "संपूर्ण जिल्हा"}</td>
                      <td className="border border-[#e2d9c4] px-2.5 py-1.5 font-latin font-semibold text-[#1b3d2a]">{a.username}</td>
                      <td className="border border-[#e2d9c4] px-2.5 py-1.5 font-latin">{DEFAULT_PW}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
        <p className="mt-6 text-right text-[11px] text-slate-400">एकूण {accounts.length} अधिकारी खाती · जिल्हाधिकारी कार्यालय, अमरावती</p>
      </div>
    </div>
  );
}
